import React, { useEffect, useState } from 'react';
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  FormInputContainer,
  MainContainer,
  MainContent,
  SubTitle,
  Title,
} from '../../../../../components/StyledComponents';
import './styles.module.scss';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import { useHistory, useParams } from 'react-router-dom';
import { MdContentCopy } from 'react-icons/md';
import Select from '../../../../../components/Select';
import { maxLength, minLength, valueIsRequired, } from '../../../../../utils/regex';
import Input from '../../../../../components/InputControlled';
import { useFieldArray, useForm } from 'react-hook-form';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { UserActionsContent } from '../../../../../components/UserActionsContent';
import { CanaisDigitaisService } from '../../../services/canaisDigitais';
import { Box, Chip, Stack, Tooltip } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BsPlusCircle } from 'react-icons/bs';


export const EditarCanaisDigitais = () => {
  const [availableUFs, setAvailableUFs] = useState([]);
  const [ufResponse, setUfResponse] = useState([]);
  const { showModal } = React.useContext(BaSeDialogContext);
  const { id } = useParams();

  const theme = createTheme({
    components: {
      MuiChip: {
        styleOverrides: {
          deleteIcon: {
            color: 'red',
            '&:hover': {
              color: 'red',
            },
          },
        },
      },
    },
  });

  const { formState: { errors},  control, handleSubmit, reset, getValues, watch } = useForm({
    defaultValues: {
      descricao: '',
      uf: '',
      ufs: [],
    },
  });

  const {
    replace,
    fields,
    append: appendUf,
    remove: removeUf,
  } = useFieldArray({
    control,
    name: 'ufs',
    rules: {
      validate: (value) => value.length > 0 ? undefined : 'Selecione pelo menos uma UF'
    },
  });

  const selectedUf = watch('uf');

  const handleFetchUfs = async () => {
    await CanaisDigitaisService.findUfs().then((resp) => {
      const tranformedResponse = resp.map((uf) => uf.sigla)
      setUfResponse(resp);
      setAvailableUFs(tranformedResponse);
    });
  };
  const isUfAlreadyAdded = fields.some((field) => field.sigla === selectedUf);

  const handleAddNewUf = () => {
    if (selectedUf && !isUfAlreadyAdded) {
      appendUf({ sigla: selectedUf });
    }
  };

  const history = useHistory();

  const handleGoHome = () => {
    history.push('/tabelas-de-controle/CanaisDigitais');
  };

  const findCanais = async () => {
    const result = await CanaisDigitaisService.find(id);
    if (result) {
      reset(result);
    }
  };

  useEffect(() => {
    findCanais();
    handleFetchUfs();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendRequest = async (dataForm) => {
    let ufsSelected = dataForm.ufs.map((uf) => ufResponse.find((availableUf) => availableUf.sigla === uf.sigla));

    try {
      const body = {
        id: dataForm.id,
        descricao: dataForm.descricao,
        ufs: ufsSelected,
        status: dataForm.status,
      };
      await CanaisDigitaisService.update(body);
      handleModalStatus({
        type: 'success',
        msgOnSuccess: `Canal digital editado com sucesso`,
        onCloseModal: handleGoHome,
        showModal,
      });
    } catch (e) {
      handleModalStatus({
        type: 'error',
        msgOnError:
          'Não foi possível editar o canal digital. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.',
        showModal,
      });
    }
  };

  const onResetFields = () => {
    reset({
      descricao: '',
      uf: '',
      ufs: [],
    });
    replace([])
  };


  return (
    <>
      <MainContainer backgroundColor={'#0061C6'}>
        <FlexDirectionRow>
          <FlexDirectionRow style={{ width: '100%' }}>
            <MdContentCopy size={40} color="#ffffff" />
            <Title>Tabelas de Controle</Title>
          </FlexDirectionRow>
          <BaSeIcon
            onClick={handleGoHome}
            name={'arrow-circle-left'}
            description="voltar"
            color="#ffffff"
            size={50}
          />
        </FlexDirectionRow>
      </MainContainer>
      <MainContent>
        <SubTitle>
          <h3>Editar</h3>
        </SubTitle>

        <FormContainer
          style={{ displayFlex: true, flexDirection: 'column' }}
          onSubmit={handleSubmit(sendRequest)}
        >
          <FormInputContainer>
            <Input
              required={true}
              minLength={3}
              maxLength={255}
              name="descricao"
              control={control}
              rules={{ ...valueIsRequired(), ...maxLength(255), ...minLength(3) }}
              placeholder={'Nome do canal digital'}
              showMaxLengthLabel={false}
            />
          </FormInputContainer>

          <Stack direction="row" alignItems="center" gap="0.5rem">
            <FormInputContainer>
              <Select
                name="uf"
                placeholder="UF"
                options={availableUFs}
                control={control}
              />

              {!!(errors?.ufs ?? errors?.ufs?.root) && (
                  <p style={{color: '#F5365C'}}>{(errors?.ufs?.message ?? errors?.ufs?.root?.message)}</p>
              )}
            </FormInputContainer>
            <button
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                marginTop: '1rem',
              }}
              onClick={handleAddNewUf}
              disabled={isUfAlreadyAdded || !selectedUf}
            >
              <BsPlusCircle
                size={20}
                color={isUfAlreadyAdded || !selectedUf ? '#9ca2a8' : '#0061C6'}
              />
            </button>


          </Stack>

          <Box width="45%" display="flex" gap="0.5rem" flexWrap="wrap">
            <ThemeProvider theme={theme}>
              {fields.map((field, index) => (
                  <Tooltip title={field.sigla}>
                    <Chip
                        label={field.sigla}
                        color="primary"
                        variant="outlined"
                        onDelete={() => removeUf(index)}
                        style={{
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                        }}
                    />
                  </Tooltip>
              ))}
            </ThemeProvider>
          </Box>

          <FlexDirectionRow position={'end'} style={{ marginRight: '40px' }}>

            <Button
                type="button"
                backgroundColor={'#9CA2A8'}
                onClick={onResetFields}
                style={{
                  marginRight: '20px',
                }}
            >
              Limpar
            </Button>

            <Button disabled={(errors?.length)} href="#" type="submit">
              Editar canal digital
            </Button>
          </FlexDirectionRow>
        </FormContainer>
      </MainContent>
      <UserActionsContent data={getValues()} />
    </>
  );
};
